import { connect } from 'react-redux';
import PromoCodeConstructor from './PromoCodeConstructor';
import { actions } from './PromoCodeConstructor.actions';

const PromoCodeConstructorComponent = connect(
    function mapStateToProps(state) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state?.user?.publisher?.id || ''
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getDataLink: actions.getDataLink
        };
    }
)(PromoCodeConstructor);

export default PromoCodeConstructorComponent;
